import React, { Component } from 'react'
import { css } from 'emotion'
import { CFLink, CFView, Space, Text } from 'components'
import {
  appStore,
  googlePlay,
  locationMap,
  locationMapDowntown,
  facebook,
  yelp,
  zomato,
} from 'images'
import { MEDIA_QUERY } from 'styles'

class Contact extends Component {
  render() {
    const { HoursElement, locationId } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.innerContainer1}>
          <div className={styles.column}>
            <Text heading2 h2 bold color="#D0021B">
              DOWNLOAD APP
            </Text>
            <Space h2 />
            <CFView w="30rem">
              <Text h6 white>
                Kiku Sushi is now taking online orders. Redeem points for
                fantastic rewards and discounts. Download our app at:
              </Text>
            </CFView>
            <Space h3 />
            <CFView row>
              <div className={styles.buttonBar}>
                <CFLink href="https://apps.apple.com/us/app/kiku-sushi-official/id1474519609?ls=1">
                  <img
                    className={styles.mobile}
                    src={appStore}
                    alt="App Store"
                  />
                </CFLink>
                <Space w2 />
                <CFLink href="https://play.google.com/store/apps/details?id=tech.codefusion.kiku">
                  <img
                    className={styles.mobile}
                    src={googlePlay}
                    alt="Goodle Play"
                  />
                </CFLink>
              </div>
            </CFView>
            <Space h3 />
            <Text heading2 h2 bold color="#D0021B">
              SOCIAL MEDIA
            </Text>
            <Space h2 />
            <div className={styles.buttonBar}>
              <CFLink href="https://www.facebook.com/kikusushidowntown/">
                <img className={styles.icon} src={facebook} alt="Facebook" />
              </CFLink>
              <Space w2 />
              <CFLink href="https://www.yelp.ca/biz/kiku-sushi-burnaby">
                <img className={styles.icon} src={yelp} alt="Yelp" />
              </CFLink>
              <Space w2 />
              <CFLink href="https://www.zomato.com/vancouver/kiku-sushi-central-burnaby">
                <img className={styles.icon} src={zomato} alt="Zomato" />
              </CFLink>
            </div>
          </div>
          <div className={styles.column}>
            <Text heading2 h2 bold color="#D0021B">
              BUSINESS HOURS
            </Text>
            <Space h2 />
            <div className={styles.hours}>{HoursElement}</div>
          </div>
        </div>
        <CFLink
          href="https://goo.gl/maps/9qVf2WTPP9BY9e2X9"
          className={styles.innerContainer2}
        >
          <img
            src={
              locationId === 'mihbDMkGvzSmBz09dE7Z'
                ? locationMap
                : locationMapDowntown
            }
            alt="Kiku Sushi Map"
            className={styles.locationMap}
          />
        </CFLink>
      </div>
    )
  }
}

const styles = {
  container: css({
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    [MEDIA_QUERY.LG]: {
      flexDirection: 'column',
      alignItems: 'center',
      padding: 0,
      textAlign: 'center',
    },
  }),
  innerContainer1: css({
    width: '55%',
    display: 'flex',
    justifyContent: 'space-evenly',
    [MEDIA_QUERY.LG]: {
      width: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      padding: 0,
      textAlign: 'center',
    },
  }),
  innerContainer2: css({
    width: '45%',
    [MEDIA_QUERY.LG]: {
      width: '100%',
    },
  }),
  locationMap: css({
    width: '100%',
    objectFit: 'contain',
    [MEDIA_QUERY.LG]: {
      marginTop: '2rem',
    },
  }),
  hours: css({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '35rem',
  }),
  mobile: css({
    height: '4rem',
    objectFit: 'contain',
    cursor: 'pointer',
    transition: 'all .2s',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  }),
  column: css({
    padding: '2rem 0',
    display: 'flex',
    flexDirection: 'column',
    alignSelf: 'center',
    [MEDIA_QUERY.MD]: {
      alignItems: 'center',
    },
  }),
  buttonBar: css({
    display: 'flex',
  }),
  icon: css({
    height: '3.5rem',
    width: '3.5rem',
    cursor: 'pointer',
    transition: 'all .2s',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  }),
}

export default Contact
